export const getShowThirdPartyModal = (state) =>
  state.thirdPartyModal.showThirdPartyModal;
export const getTargetURL = (state) => state.thirdPartyModal.targetURL;
